module.exports = __webpack_public_path__ + "img/jiankang@3x.17615ef4.png";